export default {
    filtered: '',
    activefilter: null,
    windowWidth: window.innerWidth,
}